import {
  getAuth,
  signInWithPopup,
  signOut,
  GoogleAuthProvider,
  OAuthProvider,
  OAuthCredential,
  Auth,
} from 'firebase/auth';
import { FirebaseApp } from 'firebase/app';

const TENANT_ID = 'acf01cd9-ddd4-4522-a2c3-ebcadef31fbb';

export type FirebaseAuthServiceProvider = 'google' | 'microsoft';

export class FirebaseAuthService {
  public static signInWithPopup(
    provider: FirebaseAuthServiceProvider,
    app?: FirebaseApp
  ): Promise<OAuthCredential> {
    const auth = getAuth(app);

    if (provider === 'google') {
      return this.getGoogleOAuthCredential(auth);
    } else if (provider === 'microsoft') {
      return this.getMicrosoftOAuthCredential(auth);
    } else {
      throw new Error(`Invalid provider`);
    }
  }

  public static signOut(app?: FirebaseApp): Promise<void> {
    const auth = getAuth(app);
    return signOut(auth);
  }

  protected static async getGoogleOAuthCredential(
    auth: Auth
  ): Promise<OAuthCredential> {
    const provider = new GoogleAuthProvider();
    provider.addScope('profile');
    provider.addScope('email');
    provider.setCustomParameters({
      prompt: 'select_account',
    });

    const result = await signInWithPopup(auth, provider);
    const credential = GoogleAuthProvider.credentialFromResult(result);

    if (!credential) {
      throw new Error('No credential returned from Google sign in');
    }

    return credential;
  }

  protected static async getMicrosoftOAuthCredential(
    auth: Auth
  ): Promise<OAuthCredential> {
    const provider = new OAuthProvider('microsoft.com');
    provider.addScope('profile');
    provider.addScope('email');
    provider.setCustomParameters({
      prompt: 'select_account',
      tenant: TENANT_ID,
    });

    const result = await signInWithPopup(auth, provider);
    const credential = OAuthProvider.credentialFromResult(result);

    if (!credential) {
      throw new Error('No credential returned from Microsoft sign in');
    }

    return credential;
  }
}
